/* ===========================================================
   Hook de instrumentação das páginas de CONTEÚDO (blog, conceitos, guia,
   calculadoras) — espelha o useLandingTracking. Fixa a superfície "conteudo",
   dispara "Conteúdo Visto" (pageview) no mount e capta cliques de CTA por
   delegação via atributo [data-cta] (ex.: botões do navbar). No-op fora de
   produção (ver mixpanel.ts). Chamado 1x por página, ao lado do useSeo.
   =========================================================== */
import { useEffect } from "react";
import { conteudoVisto, ctaClicado, marcarSuperficie } from "./events";

export interface ConteudoMeta {
  tipo: "blog" | "artigo" | "conceito" | "guia" | "calculadora";
  categoria?: string;
  titulo?: string;
}

export function useContentTracking({ tipo, categoria, titulo }: ConteudoMeta): void {
  useEffect(() => {
    marcarSuperficie("conteudo");
    conteudoVisto({ path: window.location.pathname, tipo, categoria, titulo });

    // Cliques de CTA por delegação — mesmo mecanismo da landing. Captura os
    // botões do navbar ([data-cta="conteudo_nav_*"]) e da faixa de conversão.
    const onClick = (ev: MouseEvent): void => {
      const alvo = ev.target;
      if (!(alvo instanceof Element)) return;
      const cta = alvo.closest<HTMLElement>("[data-cta]");
      if (cta?.dataset.cta) ctaClicado(cta.dataset.cta);
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [tipo, categoria, titulo]);
}
